export default {
  AUTOMATIC_PENDING_TREATMENT: 'AUTOMATIC_PENDING_TREATMENT',
  CANCELED: 'CANCELED',
  PENDING_TREATMENT: 'PENDING_TREATMENT',
  REJECTED: 'REJECTED',
  TREATED: 'TREATED'
};
